import { render, staticRenderFns } from "./WriteContentBtn.vue?vue&type=template&id=79dcd6f7&"
import script from "./WriteContentBtn.vue?vue&type=script&lang=ts&"
export * from "./WriteContentBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports